import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RedirectHelperService } from 'src/app/shared/services/redirect-helper/redirect-helper-service';

// TODO: adjust it to new payments flow
@Component({
  selector: 'mytc-sign-in-bar',
  templateUrl: './sign-in-bar.component.html',
  styleUrls: ['./sign-in-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SignInBarComponent {
  constructor(private redirectHelper: RedirectHelperService) {}

  @Input() showSignInButton = true;

  signIn(): void {
    this.redirectHelper.redirectToLoginPage();
  }
}
